import { render, staticRenderFns } from "./VideoOverlayTrigger.vue?vue&type=template&id=1b091416&"
import script from "./VideoOverlayTrigger.vue?vue&type=script&lang=js&"
export * from "./VideoOverlayTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports